<fc-search-many-input
  [label]="'SEGMENTS.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayWith]="displayWith"
  tooltipPosition="above"
  [desiredStyle]="desiredStyle"
  [disabled]="disabled"
></fc-search-many-input>
